export const MIN_ACCOUNT_CATEGORY = 100;
export const MAX_ACCOUNT_CATEGORY = 104;
